export default "__VITE_ASSET__af81ae3a__"